import { cn } from "src/helpers";

export const BANNERS = [
  (selectedIndex: number) => (
    <div>
      <span className={cn("font-bold text-lg text-primary", { "text-white": selectedIndex === 0 })}>
        {" "}
        Commercial & Industrial(C&I) customers
      </span>
    </div>
  ),
  (selectedIndex: number) => (
    <div>
      <span className={cn("font-bold text-lg text-primary", { "text-white": selectedIndex === 1 })}>
        Residential Customers
      </span>
    </div>
  ),
  (selectedIndex: number) => (
    <div>
      <span className={cn("font-bold text-lg text-primary", { "text-white": selectedIndex === 2 })}>
        Residential{" "}
        <span className={cn("text-primary-hover ", { "text-white underline underline-offset-2": selectedIndex === 2 })}>
          Societies
        </span>
      </span>
    </div>
  ),
  (selectedIndex: number) => (
    <div>
      <span className={cn("font-bold text-lg text-primary", { "text-white": selectedIndex === 3 })}>
        Energy Trading
      </span>
    </div>
  ),
  (selectedIndex: number) => (
    <div>
      <span className={cn("font-bold text-lg text-primary", { "text-white": selectedIndex === 4 })}>
        Technology Solutions
      </span>
    </div>
  ),
];
